import { Component, effect, inject, Input, Output, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { EventEmitter } from '@angular/core';
import { CounterComponent } from '@shared/components/counter/counter.component';
import { DatepickerService } from '@shared/services/datepicker.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';

@Component({
 selector: 'iho-extra-person-counter',
 standalone: true,
 imports: [CommonModule, SharedModule, CounterComponent],
 templateUrl: './extra-person-counter.component.html',
 styleUrls: ['./extra-person-counter.component.scss'],
})
export class ExtraPersonCounterComponent {
 @Input() extraPersonData: any = 0;
 @Input() FixedGuestCount: any = 1;
 @Output() extraPersonOutput = new EventEmitter<Record<string, any>>();
 nop: WritableSignal<number> = signal(0);
 status: WritableSignal<string> = signal('');
    datePickerService = inject(DatepickerService);
    searchBoxService = inject(SearchBoxService);
    pdpUiService = inject(HotelInfoUiService);

 constructor() {
   
 }

 updateNumberOfPeople(type: string, value: any) {
  this.nop.set(value);
  this.extraPersonOutput.emit({
   nop: this.nop(),
   fixed: this.FixedGuestCount,
  });
 }
}
